export const environment = {
	production: false,
	url: "https://api-claims.policystreet.app",
};
